import React, { useState } from 'react';
import { Box, Divider, TextField, Typography, useTheme } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { verifyOtpSchema } from '../../helpers/validations/forgotPasswordValidation';
import { ROUTES } from '../../constants/routes';
import { useSnackbar } from '../../components/MUIComponent/FeedbackComponent/SnackBar/SnackbarContext';
import Button from '../../components/Button/Button';
import { useSelector } from 'react-redux';
import '../../styles/layout/_mainLayout.scss';
import FeatureSlider from '../../pages/SignIn/FeatureSlider';
import { Admin2FAOtpVerify, Employee2FAOtpVerify, Parent2FAOtpVerify, Student2FAOtpVerify } from '../../api/auth/authService';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../../features/auth/authSlice';
import { useAuth } from '../../hooks/useAuth';
import { Roles } from '../../constants/params/constants';
import Cookies from 'js-cookie';
import { getSchoolProfileSuccess } from '../../features/schoolProfile/schoolProfileSlice';
import { StudentVisitByParent } from '../../api/StudentService/StudentServide';
import { GetAllAcademicYearList } from '../../api/SchoolService/SchoolService';
import { setAcademicYearList } from '../../features/academicYear/academicYearListSlice';
import { loginKidSuccess } from '../../features/auth/kidAuthSlice';
import { setSelectedSchool } from '../../features/schoolProfile/selectedSchoolSlice';
import { setStudentAcadYear } from '../../features/academicYear/addStudentAcadYearSlice';
import configAPI from '../../api/config';
import { setAcademicYear } from '../../features/academicYear/academicYearSlice';
import { useTranslation } from 'react-i18next';
const TwoAuthenticationOtpVerify = ({ formData }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { user } = useAuth();
  const dispatch = useDispatch();
  const isDark = theme.palette.mode === 'dark';
  const [position, setPosition] = React.useState(50);
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const routeName = currentLocation.pathname;
  const { showSnackbar } = useSnackbar();
   const [rememberMe, setRememberMe] = useState(false);
    const { schoolProfileData } = useSelector(state => state.schoolProfile);
  const [academicYearList, setAcademicYearDataList] = React.useState([]);
  const forgotToLoginMap = {
    [ROUTES.ADMINFORGOTPASSWORD]: ROUTES.ADMINSIGNIN,
    [ROUTES.PARENTFORGOTPASSWORD]: ROUTES.PARENTSIGNIN,
    [ROUTES.EMPLOYEEFORGOTPASSWORD]: ROUTES.EMPLOYEESIGNIN,
    [ROUTES.FORGOTPASSWORD]: ROUTES.STUDENTSIGNIN,
  };

  const backToLoginPath = forgotToLoginMap[routeName] || ROUTES.STUDENTSIGNIN;
  const customColors = useSelector(state => state.theme.customColors);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(verifyOtpSchema),
  });


  const fetchAcademicYearList = async (schoolID) => {
    try {
      
   
      const formData = new FormData();
      formData.append("SchoolID", schoolID)
      const res = await GetAllAcademicYearList(formData);
      if (res.success) {
        const list = res?.data.length > 0 ? res?.data.filter(acd => acd.status === "Active") : [];
        dispatch(setAcademicYearList(list));

        const toLocalDateString = (date) => {
          const d = new Date(date);
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const day = String(d.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };
        const todayStr = toLocalDateString(new Date());
        let current = list.find(session => {
          const startStr = toLocalDateString(session.startDate);
          const endStr = toLocalDateString(session.endDate);

          return todayStr >= startStr && todayStr <= endStr;
        });

        if (!current && list.length > 0) {
          current = [...list].sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )[0];
        }

        const schoolProfileUpdate = { ...schoolProfileData, academicYearEnd: current.startDate, academicYearStart: current.endDate };
        dispatch(getSchoolProfileSuccess(schoolProfileUpdate));
        dispatch(setAcademicYear(current));
        dispatch(setStudentAcadYear(current));
      } else {
        setAcademicYearDataList([]);
      }
    } catch (error) {
      setAcademicYearDataList([]);
      // showSnackbar('Failed to fetch academic year list', 'warning');
    } 
  };
   const getFullImageUrl = path => {
      if (!path) return null;
      if (path.startsWith('http') || path.startsWith('https')) return path;
      return `${configAPI.REACT_APP_IMAGE_DYNAMIC_URL}${path}`;
    };
const completeLogin = async (data) => {
  if (data.success === true) {
          const responseData = data;
          localStorage.setItem("token", responseData?.data?.accessToken)
          localStorage.setItem("refreshToken", responseData?.data?.refreshToken)
  
          const documents = JSON.parse(responseData?.data?.documents || '[]');
          const profileDoc = documents.find(doc => doc.DocumentName === "Profile Image");
          const ProfileUrl = profileDoc?.DocumentImage || '';
  
          const isSchoolListRole =
            responseData?.data?.roleName === Roles[5].RoleName ||
            responseData?.data?.roleName === Roles[6].RoleName ||
            responseData?.data?.roleName === Roles[2].RoleName ||
            responseData?.data?.roleName === Roles[0].RoleName;
  
          const isSchoolListRoleSchoolList =
            responseData?.data?.roleName === Roles[5].RoleName ||
            responseData?.data?.roleName === Roles[6].RoleName ||
            responseData?.data?.roleName === Roles[0].RoleName;
  
          if (isSchoolListRole) {
            if (responseData?.data?.roleName === Roles[2].RoleName) {
              const res = await fetchAcademicYearList(responseData?.data?.schoolID);
            } else {
              const res1 = await fetchAcademicYearList(responseData?.data?.schoolID);
            }
          } else {
            const acadyear = responseData?.data?.academicYear || {};
            const schoolProfileUpdate = { ...schoolProfileData, academicYearEnd: acadyear?.startDate ?? null, academicYearStart: acadyear?.endDate ?? null };
            dispatch(getSchoolProfileSuccess(schoolProfileUpdate));
            dispatch(setAcademicYear(acadyear));
            dispatch(setStudentAcadYear(acadyear));
          }
  
          const payload = {
            classID: responseData?.data?.studentClassDetails?.[0]?.classID,
            sectionID: responseData?.data?.studentClassDetails?.[0]?.sectionID,
            streamID: responseData?.data?.studentClassDetails?.[0]?.streamID,
            subStreamID: responseData?.data?.studentClassDetails?.[0]?.subStreamID,
            studentID: responseData?.data?.studentID,
            employeeID: responseData?.data?.employeeID,
            adminID: responseData?.data?.adminID,
            parentID: responseData?.data?.parentID,
            firstName: responseData?.data?.firstName,
            fullName: responseData?.data?.fullName,
            lastName: responseData?.data?.lastName,
            email: responseData?.data?.email,
            userName: responseData?.data?.userName,
            authEmail: responseData?.data?.authEmail,
            isEnable: responseData?.data?.isEnable,
            parentOrGuardianEmailID: responseData?.data?.parentOrGuardianEmailID,
            phoneNumber: responseData?.data?.phoneNumber,
            roleID: responseData?.data?.roleID,
            roleName: responseData?.data?.roleName,
            schoolsRoutes: responseData?.data?.schoolsRoutes,
            routes: responseData?.data?.routes,
            groupID: responseData?.data?.groupID,
            schoolID: responseData?.data?.schoolID,
            schoolName: responseData?.data?.schoolName,
            schoolLicense: responseData?.data?.schoolLicense,
            isParentVisitStudentDash: responseData?.data?.isParentVisitStudentDash,
            ProfileUrl: responseData?.data?.profileImage || ProfileUrl,
            registrationNumber: responseData?.data?.registrationNumber,
            className: responseData?.data?.studentClassDetails?.[0]?.className,
            sectionName: responseData?.data?.studentClassDetails?.[0]?.sectionName,
            streamName: responseData?.data?.studentClassDetails?.[0]?.streamName,
            subStreamName: responseData?.data?.studentClassDetails?.[0]?.subStreamName,
            parentStudentList: responseData?.data?.parentStudentList,
            schoolList: responseData?.data?.schoolList,
            classTeacher: responseData?.data?.classTeacher || [],
            IsDefaultPassword: responseData?.data?.isDefaultPassword,
            houseId: responseData?.data?.houseId,
            houseName: responseData?.data?.houseName,
          };
          if (responseData?.data?.schoolList !== undefined && Array.isArray(responseData?.data?.schoolList)) {
            let selected = null;
            if (!selected) {
              selected =
                responseData?.data?.schoolList.find(sch => sch.schoolID === responseData?.data?.schoolID) || responseData?.data?.schoolList[0];
            }
            dispatch(setSelectedSchool(selected));
          } else {
            const fallbackOption = {
              schoolName: responseData?.data?.schoolName,
              schoolBranchName: responseData?.data?.schoolBranchName,
              schoolID: responseData?.data?.schoolID,
              schoolLogo: getFullImageUrl(responseData?.data?.schoolLogo),
            };
            dispatch(setSelectedSchool(fallbackOption));
          }
  
          if (responseData?.data?.roleName === Roles[3].RoleName && responseData?.data?.parentStudentList.length > 0) {
            dispatch(loginKidSuccess(payload))
          }
          else {
            dispatch(loginSuccess(payload))
          }
          if (responseData?.data?.roleName === Roles[3].RoleName && responseData?.data?.parentStudentList.length > 0) {
            try {
              
  
              const payloadVisit = {
                ParentID: responseData?.data?.parentID,
                StudentID: responseData?.data?.parentStudentList[0].studentID
              }
              const res = await StudentVisitByParent(payloadVisit);
              if (res?.success) {
                const responseData = res;
                const documents = JSON.parse(responseData?.data?.documents || '[]');
                const profileDoc = documents.find(doc => doc.DocumentName === "Profile Image");
                const ProfileUrl = profileDoc?.DocumentImage || '';
                const kidPayload = {
                  classID: responseData?.data?.studentClassDetails?.[0]?.classID,
                  sectionID: responseData?.data?.studentClassDetails?.[0]?.sectionID,
                  studentID: responseData?.data?.studentID,
                  employeeID: responseData?.data?.employeeID,
                  adminID: responseData?.data?.adminID,
                  firstName: responseData?.data?.firstName,
                  fullName: responseData?.data?.fullName,
                  lastName: responseData?.data?.lastName,
                  email: responseData?.data?.email,
                  phoneNumber: responseData?.data?.phoneNumber,
                  roleID: responseData?.data?.roleID,
                  roleName: responseData?.data?.roleName,
                  routes: responseData?.data?.routes,
                  schoolID: responseData?.data?.schoolID,
                  schoolName: responseData?.data?.schoolName,
                  isParentVisitStudentDash: responseData?.data?.isParentVisitStudentDash,
                  ProfileUrl: responseData?.data?.profileImage || ProfileUrl,
                  registrationNumber: responseData?.data?.registrationNumber,
                  className: responseData?.data?.studentClassDetails?.[0]?.className,
                  sectionName: responseData?.data?.studentClassDetails?.[0]?.sectionName,
                  streamName: responseData?.data?.studentClassDetails?.[0]?.streamName,
                  subStreamName: responseData?.data?.studentClassDetails?.[0]?.subStreamName,
                  parentStudentList: responseData?.data?.parentStudentList,
                  houseId: responseData?.data?.houseId,
                  houseName: responseData?.data?.houseName,
                };
  
                dispatch(loginSuccess(kidPayload));
              }
            } catch (error) {
              showSnackbar(t('messages.failedToLoadClasses'), "error");
            }
  
  
  
          } else {
            dispatch(loginKidSuccess(null));
          }
  
          // if (responseData?.data?.schoolLicense == null){
          //   showSnackbar("School license is unavailable", "warning");
          //   navigate('/trial-ended')
          // } else if (responseData?.data?.schoolLicense?.remainingDays === 0){
          //   showSnackbar("School license have expired", "warning");
          //   navigate('/trial-ended')
          // } else {
          navigate('/');
          // }
  
          if (rememberMe) {
            // Cookies.set('auth', JSON.stringify(responseData), {
            //     expires: 7,
            //     secure: true,
            //     sameSite: 'Strict',
            // });
            const isSecure = window.location.protocol === 'https:';
  
            Cookies.set('savedUsername', data.UserName, {
              expires: 7,
              sameSite: 'Lax',
              secure: isSecure,
            });
            Cookies.set('savedPassword', data.Password, {
              expires: 7,
              sameSite: 'Lax',
              secure: isSecure,
            });
          } else {
            Cookies.remove('auth');
            Cookies.remove('savedUsername');
            Cookies.remove('savedPassword');
          }
  
          showSnackbar(t('messages.loginSuccessful'), 'success');
        }
};

  const onSubmit = async data => {
    try {
       
      const payload = {
        userName: formData.email,
        otp: data.otp,
        
      };

      let response;

    //   switch (routeName) {
    //     case '/admin-forgot-password':
    //       response = await adminVerifyOtp(payload);
    //       if (response?.success) {
    //         // toast.success('Password reset successful!');
    //         showSnackbar('Password reset successful!', 'success');
    //         navigate('/admin-login');
    //       } else {
    //         showSnackbar('Invalid OTP.', 'error');
    //       }
    //       break;

    //     case '/parent-forgot-password':
    //       response = await parentVerifyOtp(payload);
    //       if (response?.success) {
    //         // toast.success('Password reset successful!');
    //         showSnackbar('Password reset successful!', 'success');
    //         navigate('/parent-login');
    //       } else {
    //         showSnackbar('Invalid OTP.', 'error');
    //       }
    //       break;

    //     case '/employee-forgot-password':
    //       response = await employeeVerifyOtp(payload);
    //       if (response?.success) {
    //         // toast.success('Password reset successful!');
    //         showSnackbar('Password reset successful!', 'success');
    //         navigate('/employee-login');
    //       } else {
    //         showSnackbar('Invalid OTP.', 'error');
    //       }
    //       break;

    //     default:
    //       response = await Student2FAOtpVerify(payload);
    //       if (response?.success) {
    //         // toast.success('Password reset successful!');
    //         showSnackbar('Password reset successful!', 'success');
    //         navigate('/student-login');
    //       } else {
    //         showSnackbar('Invalid OTP.', 'error');
    //       }
    //       break;
    //   }
switch (routeName) {
  case ROUTES.ADMINSIGNIN:
    response = await Admin2FAOtpVerify(payload);

    if (response?.success) {
      completeLogin(response);
    } else {
      showSnackbar(
        response?.message || t('header.messages.invalidOtpPleaseEnterTheCorrect'),
        'error'
      );
    }
    break;

  case ROUTES.PARENTSIGNIN:
    response = await Parent2FAOtpVerify(payload);

    if (response?.success) {
      completeLogin(response);
    } else {
      showSnackbar(
        response?.message || t('header.messages.invalidOtpPleaseEnterTheCorrect'),
        'error'
      );
    }
    break;

  case ROUTES.EMPLOYEESIGNIN:
    response = await Employee2FAOtpVerify(payload);

    if (response?.success) {
      completeLogin(response);
    } else {
      showSnackbar(
        response?.message || t('header.messages.invalidOtpPleaseEnterTheCorrect'),
        'error'
      );
    }
    break;

  case ROUTES.STUDENTSIGNIN:
    response = await Student2FAOtpVerify(payload);

    if (response?.success) {
      completeLogin(response);
    } else {
      showSnackbar(
        response?.message || t('header.messages.invalidOtpPleaseEnterTheCorrect'),
        'error'
      );
    }
    break;

  default:
    showSnackbar(t('header.messages.invalidLoginRoute'), 'error');
    break;
}
    } catch (err) {
      // toast.error(err.message || 'Invalid OTP or error verifying. Please try again.');
      showSnackbar(err.message || t('messages.invalidOtpOrErrorVerifyingPlease'), 'error');
    }
  };

  const onFormError = formErrors => {
    const firstError = Object.values(formErrors)[0];
    if (firstError?.message) {
      // toast.error(firstError.message);
      showSnackbar(firstError.message, 'error');
    }
  };

  return (
    <>
      <Box
        position={'relative'}
        sx={{ 
      // backgroundImage: 'linear-gradient(120deg,#edf7f3,#fff5e8)' 
   backgroundImage: 'url(/assets/images/studentdash/voilogin-bg.png)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    // backgroundPosition: 'center'
      }}
      >
        {/* <Box py={2} px={{ xs: 2, sm: 3, md: 4, lg: 5 }} zIndex={1} position={'relative'}>
          <Box
            component="img"
            src="/assets/images/logo/brandlogo.png"
            alt="Logo"
            sx={{
              width: 160,
              height: 'auto',
              zIndex: 10,
            }}
          />
        </Box> */}
        <Box
          display={'flex'}
          alignItems={'center'}
          // minHeight={`calc(100vh - 68px)`}
          minHeight={`calc(100vh)`}
          width={'100%'}
          zIndex={1}
          position={'relative'}
        >
          <Box
            display={'flex'}
            justifyContent={{ xs: 'center', sm: 'center', md: 'center', lg: 'center' }}
            px={{ xs: 0, sm: 3, md: 4, lg: 5 }}
            flexWrap={'wrap'}
            width={'100%'}
            gap={{ xs: 0, sm: 3, md: 3, lg: 3 }}
          >
            {/* <EventLoginCard /> */}
            <Box display={'flex'}  bgcolor="#fff" borderRadius={2} width={{ xs: '90%', sm: 'initial', md: 'initial', lg: 'initial', xl: 'initial'}} overflow={'hidden'}>
            <Box
              className=" portal-card"
              width={{ xs: '100%', sm: 500, md: 500, lg: 500, xl: 550 }}
            >
              <Box height={'100%'}                   borderRight={'solid 1px #e2e8f0'}
                  borderBottom={0}>
                <Box
                  className="dashboard-card form_card"

                pl={{ xs: 2, sm: 4, md: 4, lg: 4, xl: 6 }}
                pr={{ xs: 2, sm: 4, md: 4, lg: 4, xl: 4 }}
                // py={9}
                py={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 6 }}
                // height={'100%'}
                borderRadius={'0!important'}
                // bgcolor="#fff"
                >
                                    <Box pb={{ xs: 2.5, sm: 2.5, md: 1, lg: 1, xl: 3 }} pt={1} position={'relative'} zIndex={1}>
        <Box
          component="img"
          src="/assets/images/logo/brandlogo.png"
          alt={t('common.logo')}
          width={{ xs: 160, sm: 160, md: 215, lg: 190, xl: 215 }}
          sx={{
            // width: 215,
            height: 'auto',
            zIndex: 10,
          }}
        />
      </Box>
                  <Box mb={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 4 }}>
                    <Typography
                      variant="h6"
                      mb={{ xs: 1, sm: 1, md: 2, lg: 1, xl: 2 }}
                      color="#1d293d"
                      className="card-title text-center"
                      fontSize={{ xs: 20, sm: 20, md: 26, lg: 22, xl: 26 }}
                    >
                      {t('header.verifyOtp')}
                    </Typography>
                    <Typography variant="body2" color="rgba(0,0,0,0.6)">
                      {t('header.enterTheOtpToCompleteYour')}
                    </Typography>
                  </Box>
                  <Box mt={2}>
                    <form onSubmit={handleSubmit(onSubmit, onFormError)} noValidate>
                      <Box
                        sx={{
                          mx: 'auto',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: {xs: 2, sm: 2, md: 2, lg: 1, xl: 2},
                          height: '100%',
                        }}
                      >
                        <TextField
                          size="small"
                          label={t('header.otp')}
                          className={`autofill_inputlog ${isDark ? 'darkmd' : 'lightmd'}`}
                          type="text"
                          variant="outlined"
                          error={!!errors.otp}
                          // {...register('otp')}
                          {...register('otp', {
                            required: t('validation.otpIsRequired'),
                            pattern: {
                              value: /^[0-9]+$/,
                              message: t('validation.otpMustContainOnlyNumbers'),
                            },
                            maxLength: {
                              value: 6,
                              message: t('validation.otpCannotBeLongerThan6'),
                            },
                            minLength: {
                              value: 6,
                              message: t('validation.otpMustBeExactly6Digits'),
                            },
                          })}
                          fullWidth
                          InputLabelProps={{
                            sx: {
                              color: '#2c2c2c',
                            },
                          }}
                          inputProps={{
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                            maxLength: 6,
                            onInput: e => {
                              e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 6);
                            },
                            placeholder: t('header.enter6DigitOtp'),
                            style: { color: '#2c2c2c' },
                          }}
                          sx={{
                            mb: 1,
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              backgroundColor: '#fff',
                              '& fieldset': {
                                borderColor: '#e2e8f0',
                              },
                              '&:hover fieldset': {
                                borderColor: '#e2e8f0',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#e2e8f0',
                              },
                            },
                            '& .MuiInputLabel-root': {
                              color: '#2c2c2c',
                              '&.Mui-focused': {
                                color: '#1976d2',
                              },
                            },
                            '& .MuiOutlinedInput-input': {
                              color: '#334155',
                            },
                          }}
                        />
                        <Box className="modal-btn-voilet">
                          <Button
                            variant="contained"
                            fullWidth
                            bgColor={theme.palette.background.bgpurple}
                            textColor={theme.palette.custom.whitetext}
                            padding="12px 10px"
                            fontSize="16px"
                            disabled={isSubmitting}
                            type="submit"
                            sx={{ width: '100%', fontWeight: 600 }}
                          >
                            {/* {isSubmitting ? 'Sending...' : 'Verify OTP'} */}
                            {isSubmitting ? (
    <div class="loaderbtn"></div>
  ) : (
    t('header.verifyOtp')
  )}
                          </Button>
                        </Box>

                        {/* <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mt: 1,
                            gap: 0.5,
                            cursor: 'pointer',
                            color: '#8f01ff',
                            textDecoration: 'none',
                          }}
                          component={Link}
                          to={backToLoginPath}
                        >
                          <i class="fa-sharp fa-regular fa-arrow-left" style={{ color: '#8f01ff' }} />
                          <Typography variant="body2" fontWeight={500}>
                            Back to Login
                          </Typography>
                        </Box> */}
                        <Divider
                          sx={{
                            mt: { xs: 2, sm: 2, md: 2, lg: 1, xl: 2 },
                             borderColor: '#adadad !important',
                            '& .MuiDivider-wrapper': {
                              fontSize: '13px',
                              fontWeight: 500,
                              color: '#adadad',
                            },
                            '--Divider-childPosition': `${position}%`,
                          }}
                        >
                      
                        </Divider>
                        <Box
                          pt={1}
                          textAlign={'center'}
                          color={'#adadad'}
                          fontSize={13}
                          fontWeight={400}
                        >
                          <Box
                            component={'span'}
                            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                            color="#adadad"
                          >
                            {t('common.privacyNotice')}
                          </Box>{' '}
                          |{' '}
                          <Box
                            component={'span'}
                            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                            color="#adadad"
                          >
                            {t('common.termOfService')}
                          </Box>
                        </Box>
                      </Box>
                    </form>
                  </Box>
                </Box>
              </Box>
              </Box>
              <Box
            className=" portal-card log-width"
            width={{ xs: '100%', sm: 500, md: 300, lg: 500, xl: 550 }}
            display={{xs: 'none', sm: 'none',md:'none',lg:'flex',xl:'flex'}}
            alignItems='center'
          >
          <Box 
          sx={{
        py:{ xs: 3, sm: 3, md: 3, lg: 6, xl: 6 },               
        // minHeight: "100%",   
        m: "auto",          
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%"
      }}>
          <FeatureSlider />
          </Box>
          </Box>
            </Box>
            {/* <AnnouncementsLoginCard /> */}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default TwoAuthenticationOtpVerify;
